import Form from 'antd/lib/form'

import 'antd/lib/form/style'

export * from 'antd/lib/form'

export default Form
